__turbopack_context__.v({
  "icon": "side-nav-link-module-scss-module___VG8WW__icon",
  "item": "side-nav-link-module-scss-module___VG8WW__item",
  "link": "side-nav-link-module-scss-module___VG8WW__link",
  "linkActive": "side-nav-link-module-scss-module___VG8WW__linkActive",
});
